import { getFullTranscript } from "@/api/endpoints/episodes";
import { EpisodeV4 } from "@/types/MentionCard";
import Error from "@components/ui/error";
import { Skeleton } from "@components/ui/skeleton";
import { useLingui } from "@lingui/react/macro";
import { useQuery } from "@tanstack/react-query";

type FullTranscriptProps = {
  episodePk: EpisodeV4["pk"];
};

export default function FullTranscript({ episodePk }: FullTranscriptProps) {
  const { t } = useLingui();

  // Server state
  const { data, isLoading, error } = useQuery({
    queryKey: ["episodes", episodePk, "full-transcript"],
    queryFn: () => getFullTranscript(episodePk),
  });

  // Helpers
  function renderError() {
    return (
      <Error
        heading={t`Åh nej!`}
        description={t`Något gick snett med att ladda hela transkriptet. Vänligen försök igen senare`}
      />
    );
  }

  return data ? (
    data.ok ? (
      <p
        className="text-sm leading-relaxed"
        dangerouslySetInnerHTML={{ __html: data.data }}
      />
    ) : (
      renderError()
    )
  ) : isLoading ? (
    <div className="space-y-4">
      <Skeleton className="h-9" />
      <Skeleton className="h-9" />
      <Skeleton className="h-9" />
    </div>
  ) : error ? (
    renderError()
  ) : null;
}
